import { useAppSelector } from "./store";

export const useAprovedProductsData = () => {
    const approvedProducts = useAppSelector((state) => state.prescriptionDetail.approvedProducts);
    return approvedProducts;
};
